import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
export default {
  name: 'AgencyRecommendList',
  data: function data() {
    return {
      agencyMemberRoleTypeEnums: [],
      props: {
        multiple: true
      },
      isSelect: false,
      // AgencyMyRecommendPageList_select
      isCreate: false,
      isUpdate: false,
      isDelete: false,
      selectForm: {
        createTime: null,
        createTimes: [],
        selectCitys: [],
        roleType: null,
        stats: 0,
        name: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      citys: [],
      agencyCount: 0
    };
  },
  methods: {
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        createTime: this.selectForm.createTime,
        selectCitys: this.selectForm.selectCitys,
        roleType: this.selectForm.roleType,
        stats: this.selectForm.stats,
        name: this.selectForm.name
      };
      if (this.selectForm.createTimes.length > 0) {
        par.createStartTime = this.selectForm.createTimes[0];
        par.createEndTime = this.selectForm.createTimes[1];
      }
      var apiUrl = 'admin/v1/agencyMember/exportAgencyMyRecommendPageList';
      this.downloadUtil.excelExport(apiUrl, par, '代理推荐统计表.xls');
    },
    getAgencyMemberRoleTypeEnums: function getAgencyMemberRoleTypeEnums() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'agency_role_type'
              });
            case 1:
              res = _context.v;
              _this.agencyMemberRoleTypeEnums = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    checkRoleType: function checkRoleType(row) {
      return this.enums.checkEnumsValue(this.agencyMemberRoleTypeEnums, row.roleType + '', '-');
    },
    checkStats: function checkStats(data) {
      if (data.stats === 0) {
        return '正常';
      } else if (data.stats === 1) {
        return '已注销';
      } else {
        return '已冻结';
      }
    },
    initCitys: function initCitys() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_BYCITYOPENING_TREE_LIST({});
            case 1:
              res = _context2.v;
              _this2.citys = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: name
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this3.enumList = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this4 = this;
      var msg = '冻结';
      if (data.stats !== 0) {
        msg = '解冻';
      }
      this.$confirm('此操作将' + msg + '该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (data.stats === 0) {
          _this4.daleteApi(index, data);
        } else {
          _this4.thawApi(index, data);
        }
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消' + msg
        });
      });
    },
    thawApi: function thawApi(index, data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                agencyId: data.agencyId
              };
              _context4.n = 1;
              return api.THAW_AGENCYMEMBER(par);
            case 1:
              _this5.$message.success('解冻成功');
              _this5.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    daleteApi: function daleteApi(index, data) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                agencyId: data.agencyId
              };
              _context5.n = 1;
              return api.FROZEO_AGENCYMEMBER(par);
            case 1:
              _this6.$message.success('冻结成功');
              _this6.initTableData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.DELETE_BATCH_AGENCYMEMBER(par);
            case 1:
              _this7.$message.success('操作成功');
              _this7.initTableData();
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    initAgencyCountApi: function initAgencyCountApi() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return api.GET_AGENCYMEMBER_SUM_COUNT();
            case 1:
              res = _context7.v;
              _this8.agencyCount = res.body;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this9 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this9.tableSelects.forEach(function (element) {
          par.push(element.agencyId);
        });
        _this9.deleteBatchApi(par);
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑代理账号');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增代理账号');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.createTime = null;
      this.selectForm.createTimes = [];
      this.selectForm.selectCitys = [];
      this.selectForm.roleType = null;
      this.selectForm.stats = 0;
      this.selectForm.name = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var par, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              par = {
                pageNo: _this0.pageNo,
                pageSize: _this0.pageSize,
                createTime: _this0.selectForm.createTime,
                selectCitys: _this0.selectForm.selectCitys,
                roleType: _this0.selectForm.roleType,
                stats: _this0.selectForm.stats,
                name: _this0.selectForm.name
              };
              if (_this0.selectForm.createTimes.length > 0) {
                par.createStartTime = _this0.selectForm.createTimes[0];
                par.createEndTime = _this0.selectForm.createTimes[1];
              }
              _context8.n = 1;
              return api.AGENCY_MY_RECOMMEND_PAGE_LIST(par);
            case 1:
              res = _context8.v;
              _this0.tableData = res.body.datas;
              _this0.pageTotal = res.body.sumDataCount;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
  }
};